import { lazy } from 'react';
import type { RouteObject } from 'react-router';

import { MainLayout } from '@/layout';

const routes: RouteObject[] = [
  {
    path: 'admin-setting',
    Component: MainLayout,
    children: [
      {
        path: '',
        children: [
          {
            path: '',
            Component: lazy(() => import('@/page/setting/AdminSettingPage')),
          },
        ],
      },
    ],
  },
];

export default routes;
